import {Typography} from '@mui/material';
import React, {useEffect} from 'react';

import {FiveStarsEnum} from 'main/analytics/gaTagsEnum';
import {MainFooter, MainHeader, PageWrapperLayout, StepProgressBar} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from '../../../hooks';

import {StyledBox, StyledContainer, StyledSubHeaderStack} from '../../styles';
import {FooterActions} from '../FooterActions';
import {ErrorEvaluating, FinishEvaluations, RefuseEvaluation} from '../Modals';
import {RatingForm} from '../RatingForm';
import {FiveStarsDetailProps} from './types';
import {useRatingModalStore} from '../../stores/useRatingModalStore';
import {useRatingValuesStore} from '../../stores/useRatingValuesStore';
import {useMotivatorsStore} from '../../stores/useMotivatorsStore';
import {useRatingStars} from '../../hooks/useRatingStars';

const {rateYourAttendance} = translations['pt-br'].privateFlow.fiveStarsRating;

export function FiveStarsDetail({ratingDetail}: FiveStarsDetailProps) {
	const {aboveMobile} = useMediaQueries();

	const {
		handlePreviousStep,
		handleNextStep,
		isSubmitting,
		motivator,
		motivatorId,
		step,
		totalSteps,
		ratingModal,
	} = useRatingStars({ratingDetail});

	const setRatingModal = useRatingModalStore(state => state.setRatingModal);
	const resetRatingValue = useRatingValuesStore(state => state.resetRatingValue);
	const resetMotivatorsValues = useMotivatorsStore(state => state.resetMotivatorValues);

	useEffect(() => {
		resetRatingValue(motivatorId);
		resetMotivatorsValues(motivator);
	}, [step]);

	return (
		<PageWrapperLayout title={rateYourAttendance}>
			<MainHeader
					dataTagId={{
						closeButton: FiveStarsEnum.CLICK_X_AVALIACAO,
					}}
				hideBackBtn
				variant="subRoute"
				title={rateYourAttendance}
				handleClose={() => setRatingModal('refuse')}>
				<StyledSubHeaderStack>
					{aboveMobile ? (
						<Typography variant="h6">{ratingDetail.values.info.info[0]}</Typography>
					) : null}
					<StepProgressBar
						currentStep={step}
						totalSteps={totalSteps}
						mt={aboveMobile ? 0 : 1}
					/>
				</StyledSubHeaderStack>
			</MainHeader>
			<StyledContainer>
				<RatingForm motivator={motivator} />
				<FooterActions
					step={step}
					totalSteps={totalSteps}
					onBack={handlePreviousStep}
					onNext={handleNextStep}
					isSubmitting={isSubmitting}
				/>
			</StyledContainer>
			<StyledBox mt="auto">
				<MainFooter customMarginBottom="32px" />
			</StyledBox>
			{ratingModal === 'success' ? <FinishEvaluations /> : null}
			{ratingModal === 'refuse' ? <RefuseEvaluation ratingDetail={ratingDetail} /> : null}
			{ratingModal === 'error' ? <ErrorEvaluating ratingDetail={ratingDetail} /> : null}
		</PageWrapperLayout>
	);
}
